import React, { useState } from "react";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "+1", // default code
    phone: "",
    subject: "",
    message: "",
    terms: false,
  });
  
  const [captchaToken, setCaptchaToken] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const countryCodes = [
    { name: "United States", code: "+1" },
    { name: "India", code: "+91" },
    { name: "United Arab Emirates", code: "+971" },


    // { name: "United Kingdom", code: "+44" },
    // { name: "Canada", code: "+1" },
    // { name: "Germany", code: "+49" },
    // { name: "France", code: "+33" },
    // { name: "Australia", code: "+61" },
    // { name: "Japan", code: "+81" },
    // { name: "Singapore", code: "+65" },
    // { name: "Switzerland", code: "+41" },
    // { name: "Netherlands", code: "+31" },
    // { name: "Sweden", code: "+46" },
    // { name: "Italy", code: "+39" },
    // { name: "Spain", code: "+34" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const verifyCaptcha = () => {
    const token = "captcha_" + Date.now();
    setCaptchaToken(token);
  };

  const resetCaptcha = () => {
    setCaptchaToken("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!captchaToken) {
      alert("Please complete the security verification before sending your message.");
      return;
    }

    if (!formData.terms) {
      alert("Please agree to the terms and conditions.");
      return;
    }

    setIsSubmitting(true);

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log("Form submitted:", formData);
      console.log("CAPTCHA Token:", captchaToken);
      
      // Reset form
      setFormData({
        name: "",
        email: "",
        countryCode: "+1",
        phone: "",
        subject: "",
        message: "",
        terms: false,
      });
      setCaptchaToken("");
      
      alert("Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Sorry, there was an error sending your message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid = () => {
    return (
      formData.name.trim() &&
      formData.email.trim() &&
      formData.phone.trim() &&
      formData.subject.trim() &&
      formData.message.trim() &&
      formData.terms &&
      captchaToken
    );
  };

  return (
    <section className="tracking-wide relative min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1516387938699-a93567ec168e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primaryBgColor/95 to-primaryBgColor/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <div className="text-white animate-fade-in">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 font-mokoto tracking-wider">
              Get in Touch With Us
            </h2>
            <p className="text-xl mb-8 opacity-90">
              Have questions or want to discuss a project? Fill out the form and
              our team will get back to you within 24 hours.
            </p>
            <div className="space-y-4">
              {/* Email Us */}
              <div className="flex items-start">
                <div className="bg-primaryBtnColor p-3 rounded-full mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Email Us</h3>
                  <p className="opacity-90">contact@example.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-xl shadow-2xl p-6 md:p-8 animate-fade-in-up">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-primaryTextColor">
                Send us a Message
              </h2>
              <p className="text-secondaryTextColor mt-2">
                We'll get back to you as soon as possible
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name and Email */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-primaryTextColor mb-1"
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryBtnColor focus:border-transparent transition duration-300"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-primaryTextColor mb-1"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryBtnColor focus:border-transparent transition duration-300"
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              {/* Country Code + Phone */}
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-primaryTextColor mb-1"
                >
                  Phone Number
                </label>
                <div className="flex">
                  <select
                    name="countryCode"
                    value={formData.countryCode}
                    onChange={handleChange}
                    className="px-3 py-3 border border-gray-300 rounded-l-lg bg-gray-50 focus:ring-2 text-gray-700 text-sm"
                  >
                    {countryCodes.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-t border-r border-b border-gray-300 rounded-r-lg focus:ring-2 focus:ring-primaryBtnColor focus:border-transparent transition duration-300"
                    placeholder="Enter your phone number"
                  />
                </div>
              </div>

              {/* Subject */}
              <div>
                <label
                  htmlFor="subject"
                  className="block text-sm font-medium text-primaryTextColor mb-1"
                  >
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryBtnColor focus:border-transparent transition duration-300"
                  placeholder="What is this regarding?"
                />
              </div>

              {/* Message */}
              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-primaryTextColor mb-1"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryBtnColor focus:border-transparent transition duration-300"
                  placeholder="Tell us how we can help you..."
                ></textarea>
              </div>

              {/* CAPTCHA Verification */}
              <div className="bg-gray-50 rounded-lg p-4 border-2 border-dashed border-gray-200">
                <div className="text-center">
                  <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      className="w-6 h-6 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </div>
                  
                  <p className="text-gray-700 mb-3 font-medium">
                    Security Verification
                  </p>
                  
                  {!captchaToken ? (
                    <button
                      type="button"
                      onClick={verifyCaptcha}
                      className="w-full py-3 px-4 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition duration-300 border border-gray-300"
                    >
                      Click to verify you're human
                    </button>
                  ) : (
                    <div className="space-y-3">
                      <div className="w-full py-3 px-4 bg-green-100 text-green-700 rounded-lg font-medium border border-green-300 flex items-center justify-center">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Verified - You're human!
                      </div>
                      <button
                        type="button"
                        onClick={resetCaptcha}
                        className="text-sm text-red-600 hover:text-red-700 font-medium"
                      >
                        Reset verification
                      </button>
                    </div>
                  )}
                  
                  <p className="text-xs text-gray-500 mt-3">
                    This helps us prevent spam and protect your information
                  </p>
                </div>
              </div>

              {/* Terms */}
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    checked={formData.terms}
                    onChange={handleChange}
                    required
                    className="w-4 h-4 text-primaryBtnColor border-gray-300 rounded focus:ring-primaryBtnColor"
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label
                    htmlFor="terms"
                    className="font-medium text-primaryTextColor"
                  >
                    I agree to the{" "}
                    <a
                      href="#"
                      className="text-primaryBtnColor hover:text-primaryBtnHoverColor"
                    >
                      terms and conditions
                    </a>
                  </label>
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={!isFormValid() || isSubmitting}
                className={`w-full py-3 px-4 rounded-lg font-semibold transition duration-300 transform shadow-lg ${
                  isFormValid() && !isSubmitting
                    ? "bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white hover:scale-105 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending...
                  </div>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Animations */}
      <style jsx>{`
        .animate-fade-in {
          animation: fadeIn 1s ease-out forwards;
        }

        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default ContactSection;